module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/level-4_start-b1890c89289e1900058901dc3e751b00.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/level-4_start.png
// module id = 883
// module chunks = 2